"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionResourceType = void 0;
var PermissionResourceType;
(function (PermissionResourceType) {
    PermissionResourceType["Institution"] = "Institution";
})(PermissionResourceType = exports.PermissionResourceType || (exports.PermissionResourceType = {}));
//# sourceMappingURL=permission-resource-type.js.map